import React from 'react';
import { useSelector } from 'react-redux';
import { TTopCategory } from 'data';
import { CategoryCard } from 'common/components';
import { getIsBot } from 'selectors';
import { CardsStyles, CategoriesWrapper } from './styles';

type CategoriesContainerProps = {
	topCategoryData: TTopCategory;
	numberOfAvailableRenderedCards: number;
	wrapperClassName?: string;
};

export const CategoriesContainer = ({
	topCategoryData,
	numberOfAvailableRenderedCards,
	wrapperClassName = '',
}: CategoriesContainerProps) => {
	const isBot = useSelector(getIsBot);

	const { categories } = topCategoryData;

	let numberOfRenderedCards = 0;

	const getIsVisible = () => {
		if (isBot) {
			return true;
		}
		return numberOfRenderedCards <= numberOfAvailableRenderedCards;
	};

	const renderCategoriesCards = () =>
		categories.map(category => {
			numberOfRenderedCards += 1;
			return (
				<CategoryCard
					className={CardsStyles}
					categoryData={category}
					cardType="catalogueOrder"
					key={`catalogue-card-${category.categoryId}`}
					isVisible={getIsVisible()}
				/>
			);
		});

	return (
		<CategoriesWrapper className={`catalogue-categories-wrapper ${wrapperClassName}`}>
			{renderCategoriesCards()}
		</CategoriesWrapper>
	);
};
